import { useState } from 'react';

export default function useModal<T = any>() {
  const [visible, setVisible] = useState<boolean>(false);
  const [state, setState] = useState<T>(undefined as T);

  const open = (state?: T) => {
    setVisible(true);
    setState(state as T);
  };
  const close = () => {
    setVisible(false);
    setState(undefined as T);
  };

  return [
    { visible, state },
    { open, close },
  ] as const;
}
